"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCustomMenuPriceRequest = void 0;
var mockCustomMenuPriceRequest = {
  storeId: 77770001,
  locationNumber: -1,
  cart: [{
    MenuItemId: 'MTO-14CP',
    itemId: 102000,
    maxToppings: 40,
    Quantity: 1,
    selectedCrust: 'Round',
    selectedToppings: [{
      toppingName: 'Extra Cheese',
      toppingCode: 'TOP-ECHS',
      toppingImage: 'f0170aca-a3f4-4a85-9fd4-5c6103b067e6',
      index: 3,
      Left: 0,
      Right: 2
    }, {
      toppingName: 'Pepperoni',
      toppingCode: 'TOP-EPEP',
      toppingImage: '254c1db6-6492-48bd-a486-5ff443e99bdb',
      index: 2,
      Left: 2,
      Right: 0
    }],
    selectedCustomOptions: [{
      id: 'B',
      title: 'Bake',
      abbreviation: 'b',
      options: [{
        value: 'Normal Bake',
        isSelected: true,
        optionId: 1,
        abbreviation: 'b',
        cultureCode: 'bake'
      }]
    }, {
      id: 'C',
      title: '',
      abbreviation: '',
      options: [{
        value: 'Cheese',
        isSelected: true,
        optionId: 1,
        abbreviation: '',
        cultureCode: ''
      }]
    }, {
      id: 'S',
      title: 'Sauce',
      abbreviation: '',
      options: [{
        value: 'Normal Sauce',
        isSelected: true,
        optionId: 2,
        abbreviation: '',
        cultureCode: ''
      }]
    }, {
      id: 'CO',
      title: 'Cut Option',
      abbreviation: '',
      options: [{
        value: 'Standard Cut',
        isSelected: true,
        optionId: 1,
        abbreviation: '',
        cultureCode: ''
      }]
    }],
    crusts: [{
      bannerPositionCode: null,
      calories: 2000,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      cvItemId: 102000,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      franchiseStoreId: 77770001,
      freeToppings: 1,
      halfToppings: 0,
      id: 0,
      imageName: 'CrustImages.Whole.MTO-14CP.2.png',
      imageUrl: null,
      imageUUID: '226830dc-6751-469d-b6dc-948b283ae92c',
      isCustomizable: true,
      isCustomMenuItem: false,
      itemCaloriesText: '2000 Cal',
      itemDescription: 'Round',
      itemId: 102000,
      itemName: 'Round',
      itemPriceId: 0,
      itemType: '',
      maxchargedToppings: 0,
      maxToppings: 40,
      menuItemCode: 'MTO-14CP',
      menuItemHasBanner: false,
      menuWarnings: null,
      menuItemHighlighted: 0,
      minToppings: 1,
      orderable: true,
      plu: 102000,
      price: 6,
      quantity: 0,
      secondsUntilUnavailable: 0,
      selectedCustomOptions: null,
      selectedCustomOptionsText: null,
      selectedToppings: null,
      selectedToppingsText: null,
      sortOrder: 0,
      toppingPrice: 0,
      toppings: null,
      toppingsGroupId: 1,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: '',
      totalServings: 1,
      webImages: null,
      locationNumber: '-1'
    }, {
      bannerPositionCode: null,
      calories: 1710,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      cvItemId: 202100,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      franchiseStoreId: 77770001,
      freeToppings: 0,
      halfToppings: 0,
      id: 0,
      imageName: 'CrustImages.Whole.MTO-14TCP.2.png',
      imageUrl: null,
      imageUUID: '30f6bf80-9301-466a-9b89-ac67cacf2c90',
      isCustomizable: true,
      isCustomMenuItem: false,
      itemCaloriesText: '1710 Cal',
      itemDescription: 'Thin Crust',
      itemId: 202100,
      itemName: 'Thin Crust',
      itemPriceId: 0,
      itemType: '',
      maxchargedToppings: 0,
      maxToppings: 40,
      menuItemCode: 'MTO-14TCP',
      menuItemHasBanner: false,
      menuWarnings: null,
      menuItemHighlighted: 1,
      minToppings: 0,
      orderable: true,
      plu: 202100,
      price: 6,
      quantity: 0,
      secondsUntilUnavailable: 0,
      selectedCustomOptions: null,
      selectedCustomOptionsText: null,
      selectedToppings: null,
      selectedToppingsText: null,
      sortOrder: 1,
      toppingPrice: 0,
      toppings: null,
      toppingsGroupId: 1,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: '',
      totalServings: 1,
      webImages: null,
      locationNumber: '-1'
    }, {
      bannerPositionCode: null,
      calories: 2530,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      cvItemId: 202900,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      franchiseStoreId: 77770001,
      freeToppings: 0,
      halfToppings: 0,
      id: 0,
      imageName: 'CrustImages.Whole.MTO-14SCP.2.png',
      imageUrl: null,
      imageUUID: '0add0f04-d9fd-4db6-92f4-3206a5f642ee',
      isCustomizable: true,
      isCustomMenuItem: false,
      itemCaloriesText: '2530 Cal',
      itemDescription: 'Stuffed Crust Round',
      itemId: 202900,
      itemName: 'Stuffed Crust Round',
      itemPriceId: 0,
      itemType: '',
      maxchargedToppings: 0,
      maxToppings: 15,
      menuItemCode: 'MTO-14SCP',
      menuItemHasBanner: false,
      menuWarnings: null,
      menuItemHighlighted: 0,
      minToppings: 0,
      orderable: true,
      plu: 202900,
      price: 8,
      quantity: 0,
      secondsUntilUnavailable: 0,
      selectedCustomOptions: null,
      selectedCustomOptionsText: null,
      selectedToppings: null,
      selectedToppingsText: null,
      sortOrder: 2,
      toppingPrice: 0,
      toppings: null,
      toppingsGroupId: 1,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: '',
      totalServings: 1,
      webImages: null,
      locationNumber: '-1'
    }, {
      bannerPositionCode: null,
      calories: 0,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      cvItemId: 201412,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      franchiseStoreId: 77770001,
      freeToppings: 1,
      halfToppings: 0,
      id: 0,
      imageName: 'CrustImages.Whole.MTO-14PEPSCP.2.png',
      imageUrl: null,
      imageUUID: '4a3f1d7a-7a50-4a75-8701-07c75676f45d',
      isCustomizable: true,
      isCustomMenuItem: false,
      itemCaloriesText: '',
      itemDescription: 'Pepperoni & Cheese Stuffed Crust Round',
      itemId: 201412,
      itemName: 'Pepperoni & Cheese Stuffed Crust Round',
      itemPriceId: 0,
      itemType: '',
      maxchargedToppings: 0,
      maxToppings: 40,
      menuItemCode: 'MTO-14PEPSCP',
      menuItemHasBanner: false,
      menuWarnings: null,
      menuItemHighlighted: 1,
      minToppings: 0,
      orderable: true,
      plu: 201412,
      price: 10,
      quantity: 0,
      secondsUntilUnavailable: 0,
      selectedCustomOptions: null,
      selectedCustomOptionsText: null,
      selectedToppings: null,
      selectedToppingsText: null,
      sortOrder: 3,
      toppingPrice: 0,
      toppings: null,
      toppingsGroupId: 1,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: '',
      totalServings: 1,
      webImages: null,
      locationNumber: '-1'
    }, {
      bannerPositionCode: null,
      calories: 2500,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      cvItemId: 202206,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      franchiseStoreId: 77770001,
      freeToppings: 0,
      halfToppings: 0,
      id: 0,
      imageName: 'CrustImages.Whole.MTO-DDDCP.2.png',
      imageUrl: null,
      imageUUID: 'eec83735-b742-4209-af35-6091262d6b51',
      isCustomizable: true,
      isCustomMenuItem: false,
      itemCaloriesText: '2500 Cal',
      itemDescription: 'DEEP!DEEP!™ Dish',
      itemId: 202206,
      itemName: 'DEEP!DEEP!™ Dish',
      itemPriceId: 0,
      itemType: '',
      maxchargedToppings: 0,
      maxToppings: 40,
      menuItemCode: 'MTO-DDDCP',
      menuItemHasBanner: false,
      menuWarnings: null,
      menuItemHighlighted: 0,
      minToppings: 0,
      orderable: true,
      plu: 202206,
      price: 9,
      quantity: 0,
      secondsUntilUnavailable: 0,
      selectedCustomOptions: null,
      selectedCustomOptionsText: null,
      selectedToppings: null,
      selectedToppingsText: null,
      sortOrder: 4,
      toppingPrice: 0,
      toppings: null,
      toppingsGroupId: 17,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: '',
      totalServings: 1,
      webImages: null,
      locationNumber: '-1'
    }]
  }],
  serviceMethod: 1
};
exports.mockCustomMenuPriceRequest = mockCustomMenuPriceRequest;